import { API_ROOT, REFRESH_PERIOD_MS, TIMEOUT_PERIOD_MS } from 'environment';

class RPCService {
    
    constructor($http, $q, $timeout, $log) {
        this.$http = $http;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$log = $log;
        this.inFlight = {};
    }

    cancelAll() {
      Object.keys(this.inFlight).forEach((handle) => this.cancel(handle));
    }

    cancel(handle) {
      if (this.inFlight[handle]) {
        this.$timeout.cancel(this.inFlight[handle].timeout);
        delete this.inFlight[handle];
      }
    }

    call(boxcaster_id, rpc_data) {
        const { $http, $timeout, $log } = this;

        // How long to wait when refreshing the RPC (to see if it's done)
        let REFRESH_PERIOD_MS = 2000;

        // How long to keep refreshing before giving up
        let TIMEOUT_PERIOD_MS = 60000;

        let deferred = this.$q.defer();
        var handle = deferred.promise;
        this.inFlight[handle] = {};

        let post = $http.post(`${API_ROOT}/boxcasters/${boxcaster_id}/rpcs`, rpc_data);

        post.success((data) => {
            let postedTime = new Date();
            // We have successfully posted the RPC. Now we refresh it until complete (or timeout).
            var refreshFn = () => {
                let get = $http.get(`${API_ROOT}/boxcasters/${boxcaster_id}/rpcs/${data.id}`);
                get.success((data) => {
                    if (data.response != null) {
                        // Got it!
                        return deferred.resolve(data.response);
                    } else {
                        // Don't got it... if it's been longer than TIMEOUT_PERIOD_MS, then give up,
                        // delete the RPC, and return an error
                        let d = new Date();
                        let elapsed = d - postedTime;
                        if (elapsed > TIMEOUT_PERIOD_MS) {
                            $http.delete(`${API_ROOT}/boxcasters/${boxcaster_id}/rpcs/${data.id}`);
                            let msg = `RPC ID ${data.id} for BoxCaster ${boxcaster_id} has timed out after ${elapsed / 1000.0} seconds and has been deleted.`;
                            deferred.reject(msg);
                            $log.error(msg);
                        } else if (this.inFlight[handle]) {
                            // Otherwise, try again later.
                            this.inFlight[handle].timeout = $timeout(refreshFn, REFRESH_PERIOD_MS);
                        } else {
                            // Looks like it was already cancelled, stop trying
                        }
                    }
                });
                get.error((msg, code) => {
                    deferred.reject(msg);
                    $log.error(msg, code);
                });
            };
            this.inFlight[handle].timeout = $timeout(refreshFn, REFRESH_PERIOD_MS);
        });

        post.error((msg, code) => {
            deferred.reject(msg);
            $log.error(msg, code);
        });

        return handle;
    }
}

angular.module('app.services').service('RPC', RPCService);


// WEBPACK FOOTER //
// ./services/rpc.js